import { render, staticRenderFns } from "./dialogext.vue?vue&type=template&id=672b5482&scoped=true"
import script from "./dialogext.vue?vue&type=script&lang=js"
export * from "./dialogext.vue?vue&type=script&lang=js"
import style0 from "./dialogext.vue?vue&type=style&index=0&id=672b5482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b5482",
  null
  
)

export default component.exports